import React from "react";
import DepartementPage from "./DepartementPage";

const AMOSeineSaintDenis93 = () => {
  return <DepartementPage dept="seine-saint-denis" />;
};

export default AMOSeineSaintDenis93;
